import { createContext } from 'react';

const ResultadoDetalleContext = createContext();

export default ResultadoDetalleContext;